
const black: string = '#000000';
const white: string = '#FFFFFF';
const gray: string = '#A8A8A8';
const lightGray: string = '#C7C7C7';
const lighterGray: string = '#F5F5F5';
const darkBlue: string = '#3F76A4'
const blue: string = '#4e98d6';
const lightBlue: string = '#E6F2FC';
const darkSlateGray: string = '#465A63';
const slateGray: string = '#6D7B83';
const red: string = '#f44336';
const cyan: string = '#5AC1DE';
const darkCyan: string = '#2ABBAC';
const orange: string = '#E6AA33';
const pineGreen: string = '#478C85';
const green: string = '#4caf50';

const level_0: number = 1400;
const level_1: number = 1399;
const level_2: number = 1398;
const level_3: number = 1397;
const level_4: number = 1396;
const level_5: number = 1395;

const ThemeConfig = {
	// Transition time for animations for whole application.
	transitionTime: 300,

	// Application layer levels.
	level_0: level_0,
	level_1: level_1,
	level_2: level_2,
	level_3: level_3,
	level_4: level_4,
	level_5: level_5,

	// This applies to text input styles, whether it should single lined or bordered.
	useSquareTheme: true,
	useBorderedInputs: true,

	/***************************************************/
	/********************** COLORS *********************/
	/***************************************************/

	primaryColor: blue,
	primaryContrastTextColor: white,
	secondaryColor: darkBlue,
	secondaryContrastTextColor: white,
	warningColor: orange,
	warningContrastTextColor: white,
	errorColor: red,
	errorContrastTextColor: white,
	infoColor: darkSlateGray,
	infoContrastTextColor: white,
	successColor: green,
	successContrastTextColor: white,
	backgroundColor: white,
	buttonDividerColor: white,
	dividerColor: lightGray,
	// TODO: REMOVE THIS COLOR ON CAT-5823
	lightBlue: lightBlue
};

export default ThemeConfig;